import colorPalette from '../config/colorPalette.json';

// Get color value from palette
export const getColor = (type) => {
  return colorPalette[type] || '';
};

// Get header/banner background color
export const getHeaderColor = () => {
  return getColor('header');
};

// Get link color
export const getLinkColor = () => {
  return getColor('link');
};

// Get link hover color
export const getLinkHoverColor = () => {
  return getColor('linkHover');
};

// Get accent color
export const getAccentColor = () => {
  return getColor('accent');
};

// Get accent hover color
export const getAccentHoverColor = () => {
  return getColor('accentHover');
};

// Get icon color
export const getIconColor = () => {
  return getColor('icon');
};

// Get button color
export const getButtonColor = () => {
  return getColor('button');
};

// Get button hover color
export const getButtonHoverColor = () => {
  return getColor('buttonHover');
};

// Get background color
export const getBackgroundColor = () => {
  return getColor('background');
};

// Get alternate background color
export const getBackgroundAltColor = () => {
  return getColor('backgroundAlt');
};


// Darker orange for text on light backgrounds and white-on-orange buttons (>= 4.5:1)
export const getLinkStrongColor = () => getColor('linkStrong');
export const getAccentStrongColor = () => getColor('accentStrong');
export const getAccentStrongHoverColor = () => getColor('accentStrongHover');
